import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import "../../shared/css/basicStyles.css";

import { getDetailsCollection } from "../../shared/api/request";
import PageCollectionVisual from "../components/CollectionVisual";
import { Serie } from "../../shared/types/Serie";
import { Collection } from "../../shared/types/Collection";
import SerieSheet from "../../series/components/SerieSheet";

const PageCollection = () => {
  const { idCollection } = useParams();
  const { state } = useLocation();

  const [data, setData] = useState<
    { series: Serie[]; collection: Collection } | undefined
  >();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [selectedSerie, setSelectedSerie] = useState<Serie | null>(null);

  const loader = useCallback(async () => {
    if (!idCollection) return;
    setIsLoading(true);
    setHasError(false);
    const res = await getDetailsCollection(idCollection);
    if (res?.collection) setData(res);
    else setHasError(true);
    setIsLoading(false);
  }, [idCollection]);

  useEffect(() => {
    loader();
  }, [loader]);

  // Coming back from the reader: reopen the serie that was being read
  useEffect(() => {
    if (!data || !state?.serieId) return;
    const serie = data.series.find((s) => s.id === state.serieId);
    if (serie) setSelectedSerie(serie);
  }, [data, state]);

  return (
    <div className="mainContainer">
      <PageCollectionVisual
        isLoading={isLoading}
        hasError={hasError}
        data={data}
        onClickSerie={setSelectedSerie}
        onRetry={loader}
      />
      <SerieSheet serie={selectedSerie} onClose={() => setSelectedSerie(null)} />
    </div>
  );
};

export default PageCollection;
